/**
 * View component for /sponsors
 *
 * Generic sponsor list view. Defaults to 'all' with:
 * this.props.dispatch(sponsorActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as sponsorActions from '../sponsorActions';
import * as studyActions from '../../study/studyActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import sponsor components
import SponsorLayout from '../components/SponsorLayout.js.jsx';
import StudyCard from '../../study/components/StudyCard.js.jsx';

// import sponsor css modules
import sponsorStyles from '../sponsorModuleStyles.css';

class SponsorsStudiesList extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    // fetch a list of your choice
    dispatch(sponsorActions.fetchSingleIfNeeded(match.params.sponsorId));
    dispatch(studyActions.fetchListIfNeeded("_organization", match.params.sponsorId));
  }

  render() {
    const { match, sponsorStore, studyStore } = this.props;

    /**
     * Retrieve the list information and the list items for the component here.
     *
     * NOTE: if the list is deeply nested and/or filtered, you'll want to handle
     * these steps within the mapStoreToProps method prior to delivering the
     * props to the component.  Othwerwise, the render() action gets convoluted
     * and potentially severely bogged down.
     */
    const selectedSponsor = sponsorStore.selected.getItem() || null;
    const studies = studyStore.util.getList("_organization", match.params.sponsorId) || [];

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */
    const isEmpty = !studies || studies.length === 0;

    return (
      <SponsorLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> { selectedSponsor ? selectedSponsor.name : "Sponsors Studies"} </h1>
              <hr/>
              { isEmpty ?
                  <h2>Empty...</h2>
                :
                  <div className="yt-row with-gutters">
                    {studies.map((study, i) =>
                      <StudyCard key={study._id} study={study} />
                    )}
                  </div>
              }
            </div>
          </section>
        </div>
      </SponsorLayout>
    )
  }
}

SponsorsStudiesList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    sponsorStore: store.sponsor
    , studyStore: store.study
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SponsorsStudiesList)
);



// WEBPACK FOOTER //
// modules/sponsor/views/SponsorsStudiesList.js.jsx